module.exports = __webpack_public_path__ + "img/icons BFr_33.d404bf43.png";